export default __webpack_public_path__ + "i18n/translations/translation-te.1060ea2b.json";